import { SiteFooter, SiteHeader } from "./SiteChrome";
import { CmsContent } from "./CmsContent";

export function TermsPage() {
  return (
    <>
      <SiteHeader />
      <main className="site-shell" style={{ paddingTop: 120, paddingBottom: 100, minHeight: "70vh" }}>
        <p className="eyebrow"><span>—</span>Legal</p>
        <h1 className="page-title">Terms & Conditions</h1>
        <div style={{ maxWidth: 720, marginTop: 24 }}>
          <CmsContent
            contentKey="terms-and-conditions"
            fallbackTitle=""
            fallbackBody="This page is being finalized. If you have questions about our terms, please contact us at info@formulasoccer.com."
          />
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
